import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=f1ab5f0a"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports